import React from 'react'
import {
  Box,
  Checkbox,
  DialogContentText,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
import { GridRowsProp } from '@mui/x-data-grid'

interface Props {
  reports: GridRowsProp
  selectedReportIds: string[]
  selectAllReports: boolean
  onToggleReport: (id: string) => void
  onToggleAllReports: () => void
}

const ShareDialogSelectReports: React.FC<Props> = ({
  reports,
  selectedReportIds,
  selectAllReports,
  onToggleReport,
  onToggleAllReports,
}) => {
  return (
    <Box mb={4}>
      <DialogContentText>
        {`1. You selected the below ${selectedReportIds.length} report(s) to share. Click next to enter recipient(s) email address(es).`}
      </DialogContentText>
      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={() => onToggleAllReports()} dense>
            <ListItemIcon>
              <Checkbox
                edge="start"
                checked={selectAllReports}
                tabIndex={-1}
                disableRipple
                inputProps={{
                  'aria-labelledby': 'checkbox-list-label-select-all',
                }}
              />
            </ListItemIcon>
            <ListItemText
              primaryTypographyProps={{ style: { fontWeight: 'bold' } }}
            >
              Select All Reports
            </ListItemText>
          </ListItemButton>
        </ListItem>
        {reports.map((r) => {
          const labelId = `checkbox-list-label-${r.id}`
          return (
            <ListItem key={r.id} disablePadding>
              <ListItemButton onClick={() => onToggleReport(r.id)} dense>
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    checked={selectedReportIds.indexOf(r.id) !== -1}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ 'aria-labelledby': labelId }}
                  />
                </ListItemIcon>
                <ListItemText>{r.title}</ListItemText>
              </ListItemButton>
            </ListItem>
          )
        })}
      </List>
    </Box>
  )
}

export default ShareDialogSelectReports
